import LocalizedStrings from "react-localization";

export const spendsTotalCardsStrings = new LocalizedStrings({
  en: {
    legend: "Legend",
    inProgress: "In Progress",
    finished: "Finished",
    error: "Error",
  },
  fr: {
    legend: "Légende",
    inProgress: "En cours",
    finished: "Terminé",
    error: "Erreur",
  },
});
